// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"82b86439","361":"3ddacd67","511":"08eabef4","767":"fb254cd0"}[chunkId] + ".chunk.js";
};